import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import SmartSidebar from "./SmartSidebar";
import MobileBottomNav from "./MobileBottomNav";
import FloatingWhatsApp from "./FloatingWhatsApp";
import { useAuth } from "../../context/AuthContext";

export default function Layout({ children, seccion, setSeccion }) {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [transitionKey, setTransitionKey] = useState(0);
  const firstRender = useRef(true);
  const mainRef = useRef(null);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setTransitionKey((prev) => prev + 1);
  }, [seccion]);

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [seccion]);

  return (
    <div className="flex h-screen">
      {/* Smart Sidebar (desktop only) */}
      <SmartSidebar
        rol={user?.rol}
        seccion={seccion}
        onChange={setSeccion}
        mobileOpen={sidebarOpen}
        setMobileOpen={setSidebarOpen}
      />

      {/* Contenido principal */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main
          ref={mainRef}
          data-app-scroll-container
          className="flex-1 overflow-y-auto bg-gray-50 p-3 pb-20 md:p-6 md:pb-6 transition-colors duration-200"
        >
          <div
            key={transitionKey}
            className="animate-page-transition h-full"
          >
            {children}
          </div>
        </main>
        {user?.rol === "cliente" && <FloatingWhatsApp />}
      </div>

      {/* Bottom navigation bar (mobile only) */}
      <MobileBottomNav seccion={seccion} onChange={setSeccion} />
    </div>
  );
}
